import { toGlobalId } from 'graphql-relay';
import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import { compose } from 'react-recompose';
import { connect } from 'react-redux';
import { SimpleLoadingComponent } from '../../utils/apollo';
import ManageUsersPage from './manage-users';
import updateHEAccount from '../../mutations/HEAccount/updateHEAccount';

const query = gql`
  query ManageUsersPage($id: ID!){
    node(id: $id) {
      id
      ... on HEAccount {
        id
        name
        primaryUser {
          id
          email
        }
        userList {
          id
          firstName
          lastName
          email
          role
          lastLogin
          created
          active
          lockStatus
          institution
          userStatus
        }
        freemium
        activeSubscriptions
      }
    }
  }
`;

const graphqlData = graphql(query, {
  options: ({ current }) => ({
    variables: {
      id: toGlobalId('HEAccount', current.viewer.idToken['custom:institution']),
    },
    fetchPolicy: 'cache-and-network',
  }),
});

const updateHEAccountMutation = graphql(updateHEAccount, { name: 'updateHEAccountMutation' });

const mapStateToProps = (state) => ({
  current: state.current,
});

export default compose(
  connect(mapStateToProps),
  SimpleLoadingComponent(graphqlData, updateHEAccountMutation),
)(ManageUsersPage);
